// 表情包
exports.EMOJ = [
  '😂', '😁', '😊', '😇', '🤗', '😏', '🤔', '😌',
  '😘', '🤩', '😋', '😝', '😎', '😱', '😨', '😳',
  '😭', '😤', '😔', '😪', '😷', '🤒', '😈', '👾',
  '👻', '🤖', '👽', '👍', '✌️', '👌', '💪', '🤙',
  '🙏', '👏', '🧚', '🐵', '🐶', '🦊', '🐰', '🐽',
  '🌹', '🌝', '☀️', '🌙', '🌟', '💦', '🔥', '🌈',
  '⚽', '️🏀', '🎾', '🏓', '🎖', '🏆', '🎼', '🎹',
  '🎮', '🎊', '🎉', '🎁', '🎈', '❤️', '️💞',
];

// 老师平时在线的开始时间
exports.ONLINE_USUALLY_START_TIME = '17:00:00';

// 老师在线的结束时间
exports.ONLINE_END_TIME = '22:00:00';

// 老师周末在线时间
exports.ONLINE_WEEKEND_START_TIME = '10:00:00';

// 未读消息提示音地址
exports.NO_READ_MESSAGE_TIP_VOICE = 'https://m.xiguacity.cn/static/messages/bubble.mp3';

// 语音入口图片地址
exports.AUDIO_ENTRY = 'https://m.xiguacity.cn/imgs_wall/recorder-icon.png';

// 移动端语音入口图片地址
exports.MOBILE_AUDIO_ENTRY = 'https://m.xiguacity.cn/xigua-im/im_test/im-voice-icon.png';

// 开始播放录音图片地址
exports.START_PLAY_AUDIO = 'https://m.xiguacity.cn/imgs_wall/record-play-icon.png';

// 结束播放录音图片地址
exports.END_PLAY_AUDIO = 'https://m.xiguacity.cn/imgs_wall/record-pause-icon.png';

// 停止录音图片地址
exports.STOP_RECORD = 'https://m.xiguacity.cn/imgs_wall/record-stop-icon.png';

// 播放语音动态效果图片
exports.PLAY_AUDIO_GIF = 'https://m.xiguacity.cn/imgs_wall/record-playing-icon.gif';

// 播放语音静态效果图片
exports.PLAY_ADUIO = 'https://m.xiguacity.cn/imgs_wall/record-icon.png';


// 轮询时间
exports.POLL_TIME = 5000;
// 推送 IM 广播消息的时间
exports.PUSH_MASS_MESSAGE_TIME = 60 * 60 * 1000 + 1  * 1000;

// 接口地址
exports.HOST = 'http://39.105.133.124:3014';

exports.PLATFORM = {
  WEB: {
    key: 'web',
    label: 'WEB',
  },
  IOS: {
    key: 'ios',
    label: 'iOS',
  },
  ANDROID: {
    key: 'android',
    label: 'Android',
  },
};

exports.CDN_BASE_URL = 'https://m.xiguacity.cn/static';
